import { NearBySuggestion, NearBySuggestionMatchType } from 'core/type/PlaceSuggestion';

export const mockGeoRadiusResult: NearBySuggestion = {
    suggestion: {
        activityId: 0,
        activityName: undefined,
        activityNameTranslated: undefined,
        addressId: undefined,
        cityAbbr: 'city',
        latitude: 13.750057,
        longitude: 100.49881,
        isPopular: false,
        isAddress: false,
        isBestSeller: false,
        isSubSuggestion: false,
        isCityPageEligible: true,
        whiteLabelToken: 'F1A5905F-9620-45E5-9D91-D251C07E0B42',
        airportCodes: undefined,
        objectTypeId: 0,
        displayNames: {
            name: 'Bangkok',
            geoHierarchyName: 'Thailand',
            categoryName: 'City',
        },
        id: 9395,
        name: 'Bangkok',
        nameTranslated: 'Bangkok',
        areaId: 0,
        areaName: undefined,
        areaNameTranslated: undefined,
        cityId: 9395,
        cityName: 'Bangkok',
        cityNameTranslated: 'Bangkok',
        countryId: 106,
        countryISO2: 'TH',
        countryName: 'Thailand',
        countryNameTranslated: 'Thailand',
        stateId: 2028,
        stateName: 'Bangkok Province',
        stateNameTranslated: 'Bangkok',
        placeType: 0,
        type: 2,
        url: '/city/thailand/bangkok',
    },
    matchType: NearBySuggestionMatchType.City,
};
